import React from "react";

import { AddEntryDateClassificationContainer } from "../../../containers";

const AddEntryDateClassification = (props) => {
  return <AddEntryDateClassificationContainer {...props} />;
};

export default AddEntryDateClassification;
